import { Layout } from "@version2/ui-package";
import React from "react";
import FullScreenFooter from "./FullScreenFooter";
import FullScreenHeader from "./FullScreenHeader";

const { Content } = Layout;

type FullScreenViewProps = {
  children: React.ReactNode;
  width?: string;
  alignItems?: string;
  style?: React.CSSProperties;
};

const FullScreenView = ({
  children,
  width = "400px",
  alignItems = "center",
  style,
}: FullScreenViewProps) => {
  return (
    <Layout className="full_screen">
      <FullScreenHeader />
      <Content
        className="full_screen__content"
        style={{ alignItems: alignItems }}
      >
        <div
          className="full_screen__content__inner"
          style={{
            maxWidth: width,
            ...style,
          }}
        >
          {children}
        </div>
      </Content>
      <FullScreenFooter />
    </Layout>
  );
};

export default FullScreenView;
